import React, { useState } from "react"
import { Container, Modal } from "@carrotfertility/carotene"
import { useSetDoneWithCarrot } from "./useQueryCaseRateRenewals"
import { DoneForNowContent } from "./DoneForNowContent"
import { ThanksForLettingUsKnowContent } from "./ThanksForLettingUsKnowContent"
import { useCurrentUser } from "../../context/user/UserContext"
import { useHistory } from "react-router-dom"
import { ErrorStep } from "./steps/ErrorStep"

export function NonStaleDoneUsingCarrotModal({
  openDoneUsingCarrotModal,
  setOpenDoneUsingCarrotModal
}: {
  openDoneUsingCarrotModal: boolean
  setOpenDoneUsingCarrotModal: (boolean) => void
}): JSX.Element {
  enum ModalContent {
    DONE_FOR_NOW,
    THANKS_FOR_LETTING_US_KNOW,
    ERROR
  }
  const { mutate, isLoading } = useSetDoneWithCarrot(true)
  const [modalContent, setModalContent] = useState(ModalContent.DONE_FOR_NOW)
  const { refreshUserInfo } = useCurrentUser()
  const history = useHistory()

  async function doneWithCarrot(): Promise<void> {
    mutate(null, {
      onSuccess: () => setModalContent(ModalContent.THANKS_FOR_LETTING_US_KNOW),
      onError: () => setModalContent(ModalContent.ERROR)
    })
  }

  async function closeThanksForLettingUsKnowModal(): Promise<void> {
    setOpenDoneUsingCarrotModal(false)
    await refreshUserInfo()
    history.push("/")
  }

  const displayModalContent = [
    {
      modalContent: ModalContent.DONE_FOR_NOW,
      component: (
        <DoneForNowContent
          showBack={false}
          takeMeBackOnClick={() => setOpenDoneUsingCarrotModal(false)}
          yesImDoneOnClick={doneWithCarrot}
          isLoading={isLoading}
        />
      )
    },
    {
      modalContent: ModalContent.THANKS_FOR_LETTING_US_KNOW,
      component: <ThanksForLettingUsKnowContent close={closeThanksForLettingUsKnowModal} />
    },
    { modalContent: ModalContent.ERROR, component: <ErrorStep /> }
  ]

  return (
    <Modal
      open={openDoneUsingCarrotModal}
      onClose={() => setOpenDoneUsingCarrotModal(false)}
      showClose={modalContent === ModalContent.DONE_FOR_NOW}
      backgroundColor={modalContent === ModalContent.ERROR ? "white" : "warmGray"}
    >
      <Container padding={["medium", "medium", "huge"]}>
        {displayModalContent.find((content) => content.modalContent === modalContent).component}
      </Container>
    </Modal>
  )
}
